import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl, intlShape } from '../../../util/reactIntl';

import css from './SectionScientificGuidance.module.css';

import ScientificGuidanceIllustration from '../../../assets/landing/scientificGuidance-img.png';
import Icons from '../../../components/Icons/Icons';

const ArrowIcon = props => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
    <path
      d="M13.5 5l7 7-7 7M20.5 12h-17"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SectionScientificGuidanceComponent = props => {
  const { className, intl, imageSrc, ctaHref, onCtaClick, ctaTestId, isCtaExternal } = props;

  const title = intl.formatMessage({ id: 'SectionScientificGuidance.title' });
  const p1 = intl.formatMessage({ id: 'SectionScientificGuidance.p1' });
  const p2 = intl.formatMessage({ id: 'SectionScientificGuidance.p2' });
  const ctaText = intl.formatMessage({ id: 'SectionScientificGuidance.cta' });

  const imgAlt = intl.formatMessage({ id: 'SectionScientificGuidance.imageAlt' });
  const showCTA = ctaHref || onCtaClick;

  const ButtonTag = ctaHref ? 'a' : 'button';
  const buttonProps =
    ButtonTag === 'a'
      ? {
          href: ctaHref,
          ...(isCtaExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {}),
        }
      : { type: 'button' };

  return (
    <section className={classNames(css.root, className)}>
      <div className={css.inner}>
        <div className={css.media}>
          <img
            className={css.illustration}
            src={imageSrc || ScientificGuidanceIllustration}
            alt={imgAlt}
            loading="lazy"
          />
        </div>

        <div className={css.content}>
          <h2 className={css.title}>{title}</h2>

          <p className={css.paragraph} dangerouslySetInnerHTML={{ __html: p1 }} />
          <p className={css.paragraph} dangerouslySetInnerHTML={{ __html: p2 }} />

          {showCTA ? (
            <div className={css.ctaRow}>
              <ButtonTag
                className={css.ctaButton}
                onClick={onCtaClick}
                data-testid={ctaTestId}
                {...buttonProps}
              >
                {ctaText}
                <Icons name="rightAngle" />
              </ButtonTag>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
};

SectionScientificGuidanceComponent.defaultProps = {
  className: null,
  imageSrc: null,
  ctaHref: null,
  onCtaClick: null,
  ctaTestId: 'scientific-guidance-cta',
  isCtaExternal: false,
};

SectionScientificGuidanceComponent.propTypes = {
  className: PropTypes.string,
  intl: intlShape.isRequired,

  imageSrc: PropTypes.string,
  ctaHref: PropTypes.string,
  onCtaClick: PropTypes.func,
  ctaTestId: PropTypes.string,
  isCtaExternal: PropTypes.bool,
};

export default injectIntl(SectionScientificGuidanceComponent);
